import {Component, EventEmitter, Input, Output} from '@angular/core';

export enum TOAST_TYPES {
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}

@Component({
  selector: 'beaconstac-toast',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent {

  TOAST_TYPES = TOAST_TYPES
  /**
   * Toast type (color)
   */
  @Input()
  type: TOAST_TYPES = TOAST_TYPES.SUCCESS;

  /**
   * Toast message
   *
   * @required
   */
  @Input()
  message = 'Normal message';

  /**
   * Optional click handler
   */
  @Output()
  onClick = new EventEmitter<Event>();

  public get classes(): string[] {
    return ['toast-bg-${this.type}', 'toast-${this.type}'];
  }

  public get iconClass(): string[] {
    if (this.type === TOAST_TYPES.SUCCESS) {
      return [`fas fa-check-circle`, `toast-icon-${this.type}`]
    }
    return ['fas fa-info-circle', 'toast-icon-${this.type}'];
  }

}
